import { useLiveHuddle } from "@app/components/live/liveHuddleContext";
import type { LightWorkspaceType } from "@app/types/user";
import { Button, Headphones01 } from "@dust-tt/sparkle";

interface HuddleButtonProps {
  owner: LightWorkspaceType;
  conversationId: string | null;
  title: string | null;
}

// The chat's call, one click away: it opens the huddle over the page with the chat's space as its
// stage, made on the first click, where people join and agents talk.
export function HuddleButton({ conversationId, title }: HuddleButtonProps) {
  const huddle = useLiveHuddle();
  if (!conversationId || !huddle) {
    return null;
  }
  const isIn = huddle.inHuddleConversationId === conversationId;
  return (
    <Button
      size="sm"
      icon={Headphones01}
      variant={isIn ? "outline" : "ghost"}
      label={isIn ? "In huddle" : undefined}
      tooltip={isIn ? "Back to the huddle" : "Huddle"}
      aria-label={isIn ? "Back to the huddle" : "Start or join a huddle"}
      onClick={() => void huddle.openHuddle(conversationId, title)}
    />
  );
}
